module.exports = __webpack_public_path__ + "static/Banner-34-57e81e203077b1d11901d46001c40956.png";